import axios, { type AxiosInstance } from 'axios';

import { resolveApiBaseUrl } from '@/shared/config';

const API_URL = resolveApiBaseUrl();

/**
 * Базовый axios instance для HTTP-клиента
 * Настраивается с базовыми параметрами
 * Interceptors настраиваются в app/providers/http-provider.ts
 */
export const instance: AxiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  withCredentials: true,
  withXSRFToken: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
